import { render, staticRenderFns } from "./1019-002.vue?vue&type=template&id=52041e9b&scoped=true&"
import script from "./1019-002.vue?vue&type=script&lang=js&"
export * from "./1019-002.vue?vue&type=script&lang=js&"
import style0 from "./1019-002.vue?vue&type=style&index=0&id=52041e9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52041e9b",
  null
  
)

export default component.exports